<template>
  <div :class="$mq" class="frame">
    <h1>{{ $t('Comeback.PersonalData.title') }}</h1>
    <div class="column">
      <ul class="data">
        <li v-if="isPro"><span class="bold">{{ $t('Comeback.PersonalData.company') }}</span>
          {{ customer.company.name }}
        </li>
        <li><span class="bold">{{ $t('Comeback.PersonalData.lastname') }}</span> {{ customer.lastName }}</li>
        <li><span class="bold">{{ $t('Comeback.PersonalData.firstname') }}</span> {{ customer.firstName }}</li>
        <li v-if="! isPro && customer.email && customer.email !== 'noemail@mega.be'"><span
            class="bold">{{ $t('Comeback.PersonalData.email') }}</span> {{ customer.email }}
        </li>
      </ul>
      <ul class="data">
        <li v-if="isPro"><span class="bold">{{ $t('Comeback.PersonalData.legalForm') }}</span>
          {{ customer.company.legalForm.toUpperCase() }}
        </li>
        <li v-if="isPro"><span class="bold">{{ $t('Comeback.PersonalData.vatNumber') }}</span>
          {{ customer.company.vatNumber.toUpperCase() }}
        </li>
        <li v-if="customer.mobile === customer.phone || customer.phone"><span
            class="bold">{{ $t('Comeback.PersonalData.phone') }}</span> {{ customer.phone }}
        </li>
        <li v-if="customer.mobile !== customer.phone && customer.mobile"><span
            class="bold">{{ $t('Comeback.PersonalData.mobile') }}</span> {{ customer.mobile }}
        </li>
        <li v-if="isPro && customer.email && customer.email !== 'noemail@mega.be'"><span
            class="bold">{{ $t('Comeback.PersonalData.email') }}</span> {{ customer.email }}
        </li>
        <li v-if="!isPro"><span class="bold">{{ $t('Comeback.PersonalData.birthdate') }}</span>
          {{ customer.birthDate | moment('DD-MM-YYYY') }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "PersonalData",
  computed: {
    ...mapState('comeback', ['customer']),
    isPro() {
      return this.customer.type === 'pro';
    },
  },
  mounted() {
    console.log('customer from personal data')
    console.log(this.customer)
  }
}
</script>

<style scoped>
.column {
  display: grid;
  grid-template-columns: 50% 50%;
}

.bold {
  font-weight: bold;
}

p {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/Comeback/ColdLoss/PersonalData.vue